var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Titulo',{attrs:{"titulo":"AVISO DE PRIVACIDAD"}}),_c('b-container',{staticClass:"mt-4 mb-5"},[_c('b-card',{staticClass:"html-content-card",staticStyle:{"height":"500px","overflow-y":"auto"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.aviso)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }